import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=7b929f2a"
import script from "./CountryFlag.vue?vue&type=script&lang=js"
export * from "./CountryFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports